import { useEffect, useState, Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Helmet, HelmetProvider } from 'react-helmet-async';

import { editarBreadcrumb } from '../../actions/breadcrumb';
import { obtenerPerfil, guardarPerfil } from '../../actions/perfil';

const Perfil = () => {

    let rutasBread = [
        {
            activo: true,
            nombre: 'Perfil',
            path: '/perfil'
        }
    ];

    const dispatch = useDispatch();

    const { usuario } = useSelector(state => state.auth);
    
    const [perfilData, setPerfilData] = useState({
        nombre: '',
        apellido: '',
        email: '',
        telefono: '',
        username: '',
        password: '',
        imagen: null
    });

    /* Guardar perfil */
    const onChange = (e) => {
        setPerfilData({
            ...perfilData, 
            [e.target.name]: e.target.value
        })
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            dispatch(guardarPerfil(perfilData));
        } catch (error) {
            return false;
        }
    }

    /* Funciones generales */
    const onViewPassword = () => {
        let perfilInputType = document.getElementById('password').type;
        if(perfilInputType === 'password')document.getElementById('password').type = 'text';
        else document.getElementById('password').type = 'password';
    }

    useEffect(() => {
        dispatch(obtenerPerfil());
    }, []);

    useEffect(() => {
        setPerfilData({
            ...perfilData,
            id: usuario?.id,
            nombre: usuario?.nombre,
            apellido: usuario?.apellido,
            email: usuario?.email,
            telefono: usuario?.telefono,
            username: usuario?.username, 
            imagen: usuario?.url_perfil ? usuario?.url_perfil : process.env.REACT_APP_PUBLIC_ROUTE + '/assets/images/perfil_placeholder.png'
        });
    }, [usuario]);

    useEffect(() => {
        dispatch(editarBreadcrumb(rutasBread));
    }, [rutasBread]);

    return(
        <Fragment>
            <HelmetProvider>
                <Helmet>
                    <style>{`
                        input[type="file"] {
                            display: none;
                        }
                        
                        .custom-file-upload {
                            border-radius: 50%;
                            display: inline-block;
                            position: relative;
                            padding: 0px;
                            cursor: pointer;
                            background: #fff;
                            margin-bottom: 25px;
                            border: 5px solid #85ac11;
                        }
                        
                        .img-wrap{
                            position: relative;
                            width: 200px;
                            height: 200px;
                            overflow: hidden;
                            border-radius: 50%;
                        }

                        .img-upload:before{
                            content: "";
                            font-family: "Font Awesome 6 Free" !important;
                            font-weight: 900;
                            font-size: 90px;
                            position: absolute;
                            padding-top: 50px;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                            text-align: center;
                            color: #caec67;
                            width: 200px;
                            height: 200px;
                            border-radius: 50%;
                            opacity: 0;
                            transition: .5s ease;
                            background-color: #fff;
                        }

                        .img-upload:hover:before{
                            opacity: 1;
                        }

                        #img-photo {
                            width: auto;
                            height: 100%;
                        }
                    `}</style>
                </Helmet>
            </HelmetProvider>

            <div className="row">
                <div className="col-md-8 offset-md-2 pb-4">
                    <h3 className="mb-3 mt-5">Información personal</h3>

                    <div className="row mb-5">
                        <div className="col-12 form-group text-center">
                            <label htmlFor="photo-upload" className="custom-file-upload fas">
                                <div className="img-wrap">
                                    <img id="img-photo" htmlFor="photo-upload" src={perfilData.imagen}/>
                                </div>
                            </label>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-4 form-group mb-3">
                            <div className="input-group">
                                <div className="form-floating">
                                    <input type="text" className="form-control" placeholder="Nombre" id="nombre" name="nombre" value={perfilData.nombre} onChange={e => onChange(e)}/>
                                    <label htmlFor="nombre">Nombre</label>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-4 form-group mb-3">
                            <div className="input-group">
                                <div className="form-floating">
                                    <input type="text" className="form-control" placeholder="Apellido" id="apellido" name="apellido" value={perfilData.apellido} onChange={e => onChange(e)}/>
                                    <label htmlFor="apellido">Apellido</label>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-4 form-group mb-3">
                            <div className="input-group">
                                <div className="form-floating">
                                    <input type="text" className="form-control" placeholder="Email de acceso" id="email" name="email" value={perfilData.email} onChange={e => onChange(e)}/>
                                    <label htmlFor="email">Correo</label>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-4 form-group mb-3">
                            <div className="input-group">
                                <div className="form-floating">
                                    <input type="text" className="form-control" placeholder="Teléfono" id="telefono" name="telefono" value={perfilData.telefono} onChange={e => onChange(e)}/>
                                    <label htmlFor="telefono">Teléfono</label>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-4 form-group mb-3">
                            <div className="input-group">
                                <div className="form-floating">
                                    <input type="text" className="form-control" placeholder="Usuario" id="username" name="username" value={perfilData.username} onChange={e => onChange(e)}/>
                                    <label htmlFor="username">Usuario</label>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-4 form-group mb-3">
                            <div className="input-group">
                                <div className="form-floating">
                                    <input type="password" className="form-control" placeholder="Contraseña de acceso" id="password" name="password" autoComplete="off" value={perfilData.password} onChange={e => onChange(e)}/>
                                    <label htmlFor="password">Contraseña</label>
                                </div>
                                <div className="input-group-append">
                                    <button className="btn btn-primary viewPassword" onClick={onViewPassword}><i className="fa-solid fa-eye"></i></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div className="row">
                        <div className="col-md-12 mt-4">
                            <button type="button" className="btn btn-success float-end" onClick={handleSubmit}>Guardar perfil</button>   
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default Perfil;